import { useEffect, useRef } from "react";
import { Link, useSearch } from "@tanstack/react-router";
import { useMutation } from "@tanstack/react-query";
import { verifyEmail } from "../../api/auth";

export default function VerifyEmailPage() {
  const { token } = useSearch({ from: "/_auth/verify-email" });
  const hasFired = useRef(false);

  const mutation = useMutation({
    mutationFn: verifyEmail,
  });

  useEffect(() => {
    if (!token || hasFired.current) return;
    hasFired.current = true;
    mutation.mutate({ token });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  if (!token) {
    return (
      <div style={{
        background: "var(--surface-card)",
        border: "1px solid var(--border-subtle)",
        borderRadius: "var(--radius-xl)",
        padding: "var(--space-8)",
        boxShadow: "var(--shadow-md), var(--ring-top)",
      }}>
        <p style={{ fontSize: 14, color: "var(--text-secondary)" }}>
          This verification link is missing its token.{" "}
          <Link to="/login" style={{ color: "var(--text-accent)", fontWeight: 600 }}>
            Back to sign in →
          </Link>
        </p>
      </div>
    );
  }

  return (
    <div style={{
      background: "var(--surface-card)",
      border: "1px solid var(--border-subtle)",
      borderRadius: "var(--radius-xl)",
      padding: "var(--space-8)",
      boxShadow: "var(--shadow-md), var(--ring-top)",
    }}>
      <div style={{ marginBottom: "var(--space-7)" }}>
        <div className="eyebrow" style={{ marginBottom: "var(--space-2)" }}>
          Account verification
        </div>
        <h1 style={{ font: "var(--type-h2)", color: "var(--text-primary)" }}>
          {mutation.isSuccess
            ? mutation.data.emailChanged
              ? "Email updated"
              : "Email verified"
            : mutation.isError
              ? "Verification failed"
              : "Verifying your email"}
        </h1>
      </div>

      {mutation.isSuccess ? (
        <p style={{ fontSize: 14, color: "var(--text-secondary)", lineHeight: 1.5 }}>
          {mutation.data.emailChanged
            ? `${mutation.data.email ?? "Your new address"} is now the email on your Atlas account.`
            : "Your email address has been confirmed."}{" "}
          <Link to="/dashboard" style={{ color: "var(--text-accent)", fontWeight: 600 }}>
            Go to dashboard →
          </Link>
        </p>
      ) : mutation.isError ? (
        <>
          <p style={{ fontSize: 14, color: "var(--text-secondary)", lineHeight: 1.5, marginBottom: 12 }}>
            This link is invalid or has expired.
          </p>
          <p style={{ fontSize: 13, color: "var(--text-muted)", lineHeight: 1.5 }}>
            You can request a new verification email from your profile page, or{" "}
            <Link to="/login" style={{ color: "var(--text-accent)", fontWeight: 600 }}>
              back to sign in
            </Link>
            .
          </p>
        </>
      ) : (
        <p style={{ fontSize: 14, color: "var(--text-secondary)", lineHeight: 1.5 }}>
          Verifying your email…
        </p>
      )}
    </div>
  );
}
